import { gql } from "@apollo/client";

export const DELETE_ARCHIVO_VISITA = gql`
  mutation DeleteArchivoVisita($idArchivoVisita: Int!) {
    deleteArchivoVisita(idArchivoVisita: $idArchivoVisita) {
      success
    }
  }
`;